import { useParams } from "react-router-dom";
import React, { useCallback, useState, useEffect } from "react";
import {
  TableRow,
  CustomCard,
  BootstrapTable,
  TableDetailCell,
  LastHeaderColumn,
  FirstHeaderColumn
} from "../common-styling";
import TableLoader from "../loader/table-loader";
import { generateDateTime } from "../../services/common-service";
import { fetchBlockedPostalCodes } from "../../services/api-declaration";
import { useTranslation } from "react-i18next";

const BlockedPostalCode = () => {
  const { t } = useTranslation();
  const [postalCodeData, setPostalCodeData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const funnelId = useParams().id;
  const getBlockedPostalCodes = async (funnelId) => {
    try {
      const response = await fetchBlockedPostalCodes(funnelId);
      setPostalCodeData(response.data.data);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };
  const getBlockedPostalCodesCb = useCallback(
    (funnelId) => getBlockedPostalCodes(funnelId),
    []
  );
  useEffect(() => {
    getBlockedPostalCodesCb(funnelId);
  }, [getBlockedPostalCodesCb, funnelId]);

  return (
    <div>
      <div className="mt-3">
        <CustomCard className="mb-3 p-3 rounded-0">
          <BootstrapTable responsive>
            <thead>
              <tr>
                <FirstHeaderColumn className="align-middle text-center">
                  {t("common.postalCode")}
                </FirstHeaderColumn>
                <LastHeaderColumn className="align-middle text-center">
                  {t("common.blockedOn")}
                </LastHeaderColumn>
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <TableLoader colSpan={2} />
              ) : (
                postalCodeData.map((item, index) => (
                  <TableRow key={index}>
                    <TableDetailCell className="py-3 align-middle text-center fw-bold">
                      {item.leadData.leadAddress?.zipCode ||
                        item.leadData.leadDetails.leadZip}
                    </TableDetailCell>

                    <TableDetailCell className="py-3 align-middle text-center fw-bold">
                      {generateDateTime(item.createdAt)}
                    </TableDetailCell>
                  </TableRow>
                ))
              )}
            </tbody>
          </BootstrapTable>
        </CustomCard>
      </div>
    </div>
  );
};
export default BlockedPostalCode;
